/** Copy for the org-admin branding live preview (banner + color chips). */
export const ACCOUNT_ADMIN_BRANDING_PREVIEW = {
  SECTION_LABEL: 'Preview',
  SQUAD_PLACEHOLDER_NAME: 'Your Squad',
  COMPANY_NAME_PLACEHOLDER: 'Your Organization',
  COLOR_PRIMARY_LABEL: 'Primary color',
  COLOR_SECONDARY_LABEL: 'Secondary color',
  /** Passed to {@link GroupHeroBanner} in preview-only mode. */
  HERO_BACK_LABEL: 'Squads',
  HERO_COMPANY_GROUP_LABEL: 'Company Group',
  HERO_EMPLOYEES_LABEL: 'members',
} as const
